import GET_ASSIGNABLE_ACCOUNTS from '@/graphql/GET_ASSIGNABLE_ACCOUNTS.gql'
import ASSIGN_DOMAIN_SERVICES from '@/graphql/ASSIGN_DOMAIN_SERVICES.gql'

import { mapState } from 'vuex'

const assignableServicesMixin = {
  computed: {
    ...mapState(['services'])
  },
  data () {
    return {
      servicesList: []
    }
  },
  methods: {
    // GET ASSIGNABLE SERVICES
    async getAssignableServices (accountId) {
      try {
        const { data } = await this.$apollo.query({
          query: GET_ASSIGNABLE_ACCOUNTS,
          variables: {
            accountId: accountId
          },
          fetchPolicy: 'network-only'
        })

        if (data.domainAssignableAccountServicesList) {
          return data.domainAssignableAccountServicesList
        }
        return {}
      } catch (err) {
        return {}
      }
    },

    async assignServices (services, accountId, domainName) {
      try {
        const { data } = await this.$apollo.mutate({
          mutation: ASSIGN_DOMAIN_SERVICES,
          variables: {
            accountId: accountId,
            domainName: domainName,
            accountServiceIds: services
          }
        })
        if (data) {
          return true
        }
        return false
      } catch (err) {
        return false
      }
    }
  }

}

export default assignableServicesMixin
